<template>
    <div class="enter mainBody">
        <div class="input_area">
            <div class="input_box">
                <div class="box_top">
                    <div class="input_group" v-if="groupList.item1.isShow">
                        <label v-if="groupList.item1.selectOrinput" class="input_label" for="select">{{groupList.item1.lable}}</label>
                        <el-select v-if="groupList.item1.selectOrinput" id="select" class="inputInner" v-model="groupList.item1.value" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item1.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <label v-if="!groupList.item1.selectOrinput" class="input_label" for="input">{{groupList.item1.lable}}</label>
                        <el-input v-if="!groupList.item1.selectOrinput" id="input" class="inputInner" v-model="groupList.item1.value" placeholder="请输入内容"></el-input>
                    </div>
                    <div class="input_group" v-if="groupList.item2.isShow">
                        <label v-if="groupList.item2.selectOrinput" class="input_label" for="select">{{groupList.item2.lable}}</label>
                        <el-select v-if="groupList.item2.selectOrinput" id="select" class="inputInner" v-model="groupList.item2.value" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item2.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <label v-if="!groupList.item2.selectOrinput" class="input_label" for="input">{{groupList.item2.lable}}</label>
                        <el-input v-if="!groupList.item2.selectOrinput" id="input" class="inputInner" v-model="groupList.item2.value" placeholder="请输入内容"></el-input>
                    </div>
                    <div class="input_group" v-if="groupList.item3.isShow">
                        <label v-if="groupList.item3.selectOrinput" class="input_label" for="select">{{groupList.item3.lable}}</label>
                        <el-select v-if="groupList.item3.selectOrinput" id="select" class="inputInner" v-model="groupList.item3.value" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item3.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <label v-if="!groupList.item3.selectOrinput" class="input_label" for="input">{{groupList.item3.lable}}</label>
                        <div>
                            <el-input style="width:65%" v-if="!groupList.item3.selectOrinput" id="input" class="inputInner" v-model="groupList.item3.value" placeholder="请输入内容"></el-input>
                            <el-select style="width:15%" :placeholde='groupList.item4.placeholder' v-model="groupList.item4.value">
                                <el-option
                                    v-for="item in groupList.item4.selectOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="box_bottom" v-if="boxBottom.isBoxBottom">
                        <label class="input_label" for="beizhu">{{boxBottom.label}}</label>
                        <el-input id="beizhu" v-model="boxBottom.input" placeholder="请输入内容"></el-input>
                </div>
            </div>
            <div class="add_box">
                <button @click='submit' class="formButton add_btn" >添加</button>
            </div>
        </div>
        <div class="table_area">
                <el-table
                :stripe='true'
                        :data="tableData"
                        height="100%"
                        style="width: 100%;"
                        >
                        <el-table-column
                            prop="materialtype_id"
                            label="材料名称"
                            align='center'
                            >
                            <template slot-scope="scope">
                                <!-- <input class="innerInput" type="text" v-model="tableData[scope.$index].materialtype_id"> -->
                                <el-select v-if="groupList.item2.selectOrinput" id="select" class="innerInput" v-model="tableData[scope.$index].materialtype_id" placeholder="请选择">
                                    <el-option
                                    v-for="item in groupList.item2.selectOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="engineerregion_id"
                            label="工区"
                            align='center'>
                            <template slot-scope="scope">
                                <!-- <input class="innerInput" type="text" v-model="tableData[scope.$index].engineerregion_id"> -->
                                <el-select v-if="groupList.item2.selectOrinput" id="select" class="innerInput" v-model="tableData[scope.$index].engineerregion_id" placeholder="请选择">
                                    <el-option
                                    v-for="item in groupList.item1.selectOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="unit"
                            label="单位"
                            align='center'>
                        </el-table-column>
                        <el-table-column
                            prop="num"
                            label="设计量"
                            align='center'>
                            <template slot-scope="scope">
                                <input  class="innerInput" type="text" v-model="tableData[scope.$index].num">
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="option"
                            label="操作"
                            align='center'>
                            <!-- <button @click='openAmend' class="tablebtn_inner btnView">修改</button> -->
                            <template slot-scope="scope">
                                <button
                                class="tablebtn_inner btnView"
                                @click="openAmend(scope.$index,scope.row)">修改</button>
                                <button
                                class="tablebtn_inner btnView"
                                @click="openDelete(scope.$index,scope.row)">删除</button>
                            </template>
                        </el-table-column>
                </el-table>

        </div>
        
    </div>
</template>

<script>
import API from '@/api/material.js'
export default {
    name:'enter',
    data(){
        return{
            value:'',
            groupList:{
                item1:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'选择工区',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:'',
                },
                item2:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'选择材料',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:'',
                },
                item3:{
                    isShow:true,
                    selectOrinput:false, //1 select 0 input
                    lable:'设计量',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:'',
                },
                item4:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'单位',
                    selectOptions:[
                        {
                            value:'米',
                            label:'米'
                        },
                    ],
                    placeHolder:'单位',
                    value:'',
                },
                length:4
            },
            boxBottom:{
                isBoxBottom:false,
                 input:'',
                 label:'备注'
                
            },
            tableData: [],
            AllClass:this.$store.state.AllClass,
        }
    },
    methods:{
        delete(index,row){
            let list = this.tableData
            let param = {
                action:'delete',
                materialuse_id:list[index].id,
            }
            return new Promise((resolve,reject)=>{
                API.deleteMaterialUseList(param).then((res)=>{
                    resolve(res)
                }).catch((err)=>{
                    console.log(err);
                    resolve(0)
                })
            }) 
        },
        openDelete(index,row) {
            this.$confirm('是否确认删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.delete(index,row).then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '删除成功',
                        type: 'success'
                        });
                        this.synchrodata();
                    }else{
                        this.$message({
                        message: '删除失败，请稍后再试',
                        type: 'error'
                        });
                    }
                }).catch(err=>{
                    console.log('1',err);
                })
            }).catch(err=>{
                console.log('2',err);
            })
        },
        amend(index,row){
            //action=update&missionarea=1&materialtypeid=2&num=7&unit=米&materialuse_id=2
            let list = this.tableData
            let param = {
                action:'update',
                engineerregion_id:list[index].engineerregion_id,
                materialtype_id:list[index].materialtype_id,
                num:list[index].num,
                materialuse_id:list[index].id,
                unit:'米'
            }
            
            return new Promise((resolve,reject)=>{
                API.updateMaterialUseList(param).then((res)=>{
                    resolve(res)
                }).catch((err)=>{
                    console.log(err);
                    resolve(0)
                })
            })
            
        },
        addMethod(){
            // action=add&missionarea=1&materialtypeid=1&num=1&unit=米

            let list = this.groupList
                let tmpValue ={
                    action:'add',
                    engineerregion_id:list.item1.value||'',
                    materialtype_id:list.item2.value||'',
                    num:list.item3.value||'',
                    unit:list.item4.value,
                };
             return new Promise((resolve,reject)=>{
                    API.AddMaterialAmount(tmpValue).then(res=>{
                        resolve(res)
                    }).then(()=>{
                        this.synchrodata();
                    }).catch((err)=>{
                        console.log(err);
                        resolve(0)
                    })
                })
                
                
                
        },
        open() {
            this.$confirm('是否确认添加, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.addMethod().then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '添加成功',
                        type: 'success'
                        });
                    }else{
                        this.$message({
                        message: '添加失败，请稍后再试',
                        type: 'error'
                        });
                    }
                })
            })
            .catch(() => {
            this.$message({
                type: 'info',
                message: '已取消添加'
            });          
            });
        },
        openAmend(index,row) {
            this.$confirm('是否确认修改, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.amend(index,row).then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '修改成功',
                        type: 'success'
                        });
                    }else{
                        this.$message({
                        message: '修改失败，请稍后再试',
                        type: 'error'
                        });
                    }
                })
               
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消修改'
            });          
            });
        },
        synchrodata(){  
                    this.getGroupList();
                    this.getTableList();
        },
        submit(){
            if(!this.verifyMainLabel()){
                this.$message({
                    message: '请填写完整参数',
                    type: 'warning'
                    });
                return
            }else{
                this.open()
              
            } 
        },
        verifyMainLabel() {
            let result = true;
           for(var i = 1;i <= this.groupList.length;i++){
                if(this.groupList[`item${i}`].value == null ||`${this.groupList[`item${i}`].value}` == ''){
                    console.log('this.groupList',this.groupList[`item${i}`].value);
                    result = false;
                }
            }
            return result
        },
        formatAreaList(lists){
        let list = lists?lists:[];
        let tmpList = [];
        for(var i = 0; i <list.length;i++){
            tmpList.push({
                value:list[i].id,
                label:list[i].engineering_region_name,
            })
        }
        return tmpList

        },
        formatMaterialList(lists){
            let tmpList = [];
            let list = lists?lists:[];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    value:list[i].id,
                    label:list[i].materialName,
                })
            }
            return tmpList
        },
        getGroupList(){
            API.getEngineerRegion(this.$store.state.API_params).then((res)=>{
                this.groupList.item1.selectOptions = this.formatAreaList(res.message.obj==null?[]:res.message.obj)
            }).catch(err=>{
                console.log(err);
            });
                this.groupList.item2.selectOptions = this.formatMaterialList(this.AllClass.AllMaterialType);

        },
        formatTableList(lists){
            let list = lists?lists:[];
            let tmpList = [];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    materialtype_id:list[i].materialtype_id,
                    engineerregion_id:list[i].engineerregion_id,
                    id:list[i].id,
                    num:list[i].num,
                    id:list[i].id,
                    unit:'米',
                    option:'修改',
                    align:'center'
                })
            }
            return tmpList
        },
        getTableList(){
            API.getMaterialUseList(this.$store.state.API_params).then((res)=>{
                this.tableData = this.formatTableList(res.message.obj||{}) ;
            }).catch(err=>{
                console.log(err);
            });
        }
    },
    mounted(){
        this.synchrodata();
    }
}
</script>

<style scoped>
.innerInput{
    border: none;
    border-radius: var(--border--radius);
    background-color: var(--subject--input);
    transition: var(--subject--transition);
    color:var(--subject--text) ;
    width: 50%;
    cursor: pointer;

}

>>>.el-input--suffix .el-input__inner{
    color: var(--subject--text);
}

</style>>


